import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import Breadcrumbs from "@/components/Breadcrumbs";
import { useAdultModeQuery, useBreadcrumbs, useMatchMedia, useScrollDirection } from "@/hooks";
import styles from "@/styles/Header.module.scss";
import classnames from "classnames";
import { useEffect, useRef } from "react";
import Stickyfill from "stickyfill";
import HeaderLogo from "./HeaderLogo";
import PrimaryNavigation from "./PrimaryNavigation";
import PrimaryNavigationForSp from "./PrimaryNavigationForSp";
import SecondaryNavigation from "./SecondaryNavigation";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function Header(_ref) {
  var _classnames;

  var noHeader = _ref.noHeader,
      noTransition = _ref.noTransition;
  var header = useRef();

  var _useAdultModeQuery = useAdultModeQuery({
    fetchPolicy: "cache-first"
  }),
      data = _useAdultModeQuery.data;

  var adultMode = data === null || data === void 0 ? void 0 : data.adultMode;

  var _useBreadcrumbs = useBreadcrumbs(),
      breadcrumbs = _useBreadcrumbs.breadcrumbs;

  var viewBreadcrumbs = breadcrumbs.length > 0;
  var direction = useScrollDirection(50);
  useEffect(function () {
    if (true && header.current) {
      // IE11 polyfill
      var stickyfill = Stickyfill();
      stickyfill.add(header.current);
    }
  }, [header.current]);
  var mobileSize = useMatchMedia([{
    query: "screen and (max-width: 780px)",
    value: true
  }], false);
  return /*#__PURE__*/_jsx("header", {
    ref: header,
    className: classnames(styles.header, (_classnames = {}, _defineProperty(_classnames, styles.viewSubHeader, !mobileSize && viewBreadcrumbs), _defineProperty(_classnames, styles.scrollUp, direction === "up"), _defineProperty(_classnames, styles.scrollDown, direction === "down"), _classnames)),
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.container,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.main,
        children: [/*#__PURE__*/_jsx(HeaderLogo, {
          adultMode: adultMode,
          noTransition: noTransition
        }), !noHeader && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(PrimaryNavigation, {}), /*#__PURE__*/_jsx(SecondaryNavigation, {})]
        })]
      }), !noHeader && /*#__PURE__*/_jsx(PrimaryNavigationForSp, {}), /*#__PURE__*/_jsx("div", {
        className: classnames(styles.sub, {
          hidden: !viewBreadcrumbs || noHeader
        }),
        children: /*#__PURE__*/_jsx(Breadcrumbs, {
          hidden: !viewBreadcrumbs
        })
      })]
    })
  });
}

export default Header;